import script from "./CollectionsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectionsPage.vue?vue&type=script&setup=true&lang=js"

import "./CollectionsPage.vue?vue&type=style&index=0&id=e6aa5f9a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6aa5f9a"]])

export default __exports__